<template>
  <div class="wrapper">
    <div class="top-panel">
      <div class="title">{{ place.name }} - 路网绘制</div>
    </div>
    <div class="container-panel">
      <div class="left-panel">
        <div class="floors-wrapper">
          <div
            class="floor"
            :class="{ active: i.id === floorId }"
            @click="changeFloor(i)"
            v-for="i in place.floors"
            :key="i.id">
            {{ i.name }}
          </div>
        </div>
        <div class="container-wrapper">
          <div class="btns">
            <div class="left">
              <div
                v-if="false"
                class="funcButton scaleButton"
                @click="onUpload('upload')">
                <img :src="uploadIcon" >
              </div>
              <div
                v-if="false"
                class="funcButton scaleButton"
                @click="onDelete">
                <img :src="deleteIcon" >
              </div>
              <div class="funcButton scaleButton" @click="showAlign">
                <img :src="alignIcon" >
              </div>
              <el-input
                class="input"
                placeholder="详细地址地址"
                v-model="placename"
                size="mini"/>
              <el-button type="primary"
                         size="mini"
                         @click="queryPlace">查询</el-button>
            </div>
            <div class="right"></div>
          </div>
          <div class="containers-box">
            <div class="containers" @click.stop="imageClick($event)">
              <div class="img" :style="{ opacity: opacity / 10 }">
                <img :src="image" alt="" >
              </div>
              <div class="map" ref="map"></div>
            </div>
            <div class="rotate">
              <div @click="changeRotate('left')">
                <i class="el-icon-caret-left"></i>
              </div>
              <div @click="changeRotate('right')">
                <i class="el-icon-caret-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="form-panel" v-if="mapShow">
        <el-button v-if="m.length >= 3"
                   type="success"
                   size="mini"
                   @click="save">保存</el-button>
        <div class="jsonViewer">
          <json-viewer
            theme="my-awesome-json-theme"
            copyable
            :value="m"></json-viewer>
          <!-- <json-viewer
            theme="my-awesome-json-theme"
            copyable
            :value="srcPoints"
          ></json-viewer>
          <json-viewer
            theme="my-awesome-json-theme"
            copyable
            :value="destPoints"
          ></json-viewer> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import _ from 'lodash';
import axios from 'axios';
import JsonViewer from 'vue-json-viewer';
import qqmap from 'qqmap';
import * as math from 'mathjs';
import { uuid2 as uuid, formatDate } from '@/utils';
import request from '@/utils/request';
import { queryAllPois, queryGis, updateGis } from '@/api/map';
import { updateFloorInfo } from '@/api/place';


const URL_ROOT = 'https://vr.aibee.cn';
const SECRET = 'secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so';

export default {
  components: { JsonViewer },
  computed: {
    floorId() {
      return parseInt(this.$route.query.floor_id, 10);
    },
    placeId() {
      return this.$route.query.place_id;
    },
    showDelete() {
      if (this.target && this.targetType === 'graphic') {
        // if (this.target.group_type === 'BlockPoint') return false;
        // 不是全景点
        if (this.target.property.type !== '91') {
          return true;
        }
      }
      return false;
    },
  },
  watch: {},
  data() {
    return {
      place: {},
      map: null,
      opacity: 3,
      placename: null,
      lat: '40.074966',
      lng: '116.244293',
      index: 0,
      x: 0,
      y: 0,
      srcPoints: [],
      destPoints: [],
      m: [],
      mapShow: false,
      uploadIcon: require('@/assets/image/upload.png'),
      deleteIcon: require('@/assets/image/delete.png'),
      alignIcon: require('@/assets/image/align_icon.png'),
      image: null,
      rotation: 0,
      zoom: 14,
    };
  },
  methods: {
    ...mapActions(['getFloorInfoInit']),
    // 地图初始化
    initMap() {
      const center = new TMap.LatLng(this.lat, this.lng);
      this.map = new TMap.Map(this.$refs.map, {
        center,
        zoom: this.zoom,
        getPitch: 0,
        viewModel: '2d',
        rotation: this.rotation, // 设置地图旋转角度
      });
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
      this.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.LOGO);
      // 添加地图加载完成监听事件
      this.map.on('tilesloaded', () => {
        // 添加监听事件
        this.mapShow = true;
      });
      this.map.on('click', this.mapClick);
      // 监听地图旋转事件
      this.map.on('rotate', () => {
        this.rotation = this.map.getRotation(); // 获取地图旋转角度
        this.map.setPitch(0);
        // console.log(this.rotation)
      });
      // console.log(TMap.constants.DEFAULT_CONTROL_ID)
      // 监听地图旋转事件
      this.map.on('zoom', () => {
        // console.log('zoom')
        this.zoom = this.map.getZoom(); // 获取地图旋转角度
      });
      // 中心点变化
      this.map.on('center_changed', () => {
        this.lat = this.map.getCenter().getLat();
        this.lng = this.map.getCenter().getLng();
      });
    },
    async init() {
      const res = await this.getFloorInfoInit();
      const place = res.find(i => i.id === parseInt(this.placeId, 10));
      const floor = place.floors.find(
        i => i.id === parseInt(this.floorId, 10),
      );
      this.place = place;
      this.floor = floor;
      const gisInfo = await queryGis({
        params: {
          floor_id: this.floor.id,
        },
      });
      this.leica_align = gisInfo.data.algin_param.leica_align || {
        image_width: 0,
        image_height: 0,
        matrix: [],
      }; // 莱卡图对齐参数
      this.image = gisInfo.data.floor_cmap;
      this.m = gisInfo.data.algin_param.m || [];
      this.zoom = gisInfo.data.algin_param.zoom || 14;
      this.rotation = gisInfo.data.algin_param.rotation || 0;
      this.lat = gisInfo.data.algin_param.lat || '40.074966';
      this.lng = gisInfo.data.algin_param.lng || '116.244293';
      // console.log(gisInfo)
      this.initMap();
    },
    // 改变地图旋转
    changeRotate(target) {
      if (target === 'left') {
        this.rotation -= 1;
      } else {
        this.rotation += 1;
      }
      this.map.setRotation(this.rotation);
    },
    fileChange(e) {
      this.isPoi = true;
      const selectedFile = e.target.files[0];
      if (!selectedFile) {
        this.importLabelingData = {};
        return;
      }
      const reader = new FileReader();
      reader.readAsText(selectedFile);
      const self = this;
      // eslint-disable-next-line func-names
      reader.onload = function () {
        try {
          const json = JSON.parse(this.result);
          self.importLabelingData = json;
          self.importDataViewerVisible = true;
        } catch (ex) {
          self.$message({
            type: 'error',
            message: '不是json文件或者json格式错误',
          });
        }
      };
    },
    changeFloor(floor) {
      window.location.href = `/#/map/gisMapRouter?place_id=${this.placeId}&floor_id=${floor.id}`;
      window.location.reload();
    },
    queryPlace() {
      const geo = new qq.maps.Geocoder();
      geo.getLocation(this.placename); // 地址
      geo.setComplete((res) => {
        // console.log(res, res.detail.location) //得到经纬度
        this.map.setZoom(14);
        this.lat = res.detail.location.lat;
        this.lng = res.detail.location.lng;
        // eslint-disable-next-line no-undef
        this.map.setCenter(new TMap.LatLng(this.lat, this.lng));
      });
      geo.setError((res) => {
        this.$message('暂未搜索到地址信息，请输入详细地址');
      });
    },
    calc() {
      // console.log('点击了')
      let pointsA = this.srcPoints.slice(-3);
      let pointsB = this.destPoints.slice(-3);
      pointsA = math.transpose(pointsA);
      pointsB = math.transpose(pointsB);

      if (math.det(pointsA) === 0) {
        console.error('not invertible');
        return;
      }
      const invA = math.inv(pointsA);
      const result = math.multiply(pointsB, invA);

      this.m = result;
      // console.log(result)
      // console.log(JSON.stringify(result))
    },
    imageClick(e) {
      this.destPoints.push([
        (e.offsetX / 800) * 4000,
        (e.offsetY / 800) * 4000,
        1,
      ]);
      console.log(this.destPoints);
    },
    mapClick(e) {
      const lng = e.latLng.lng;
      const lat = e.latLng.lat;
      this.srcPoints.push([lng, lat, 1]);
      if (this.m.length > 0) {
        let point = math.multiply(this.m, math.matrix([[lng], [lat], [1]]));
        point = point.toArray();
        this.x = (point[0][0] / 4000) * 800;
        this.y = (point[1][0] / 4000) * 800;
      }
      if (this.srcPoints.length >= 3 || this.destPoints.length >= 3) {
        setTimeout(() => {
          this.calc();
        }, 30);
      }
    },
    // 自适应
    resizeHandler() {},
    showAlign() {
      this.opacity += 1;
      if (this.opacity > 10) {
        this.opacity = 0;
      }
    },
    onUpload(val) {},
    onDelete() {},
    async save() {
      const { error_no } = await updateGis({
        data: {
          floor_id: this.floor.id,
          floor_cmap: this.image,
          algin_param: {
            m: this.m,
            zoom: this.zoom,
            rotation: this.rotation,
            lat: this.lat,
            lng: this.lng,
            leica_align: this.leica_align,
          },
        },
      });
      await updateFloorInfo({
        floor_id: this.floor.id,
        theta: this.rotation,
        north: this.rotation,
      });
      // console.log('保存了')
      if (error_no === 0) {
        this.$message({
          type: 'success',
          message: '保存成功',
        });
      }
    },
  },
  mounted() {
    this.init();
    window.addEventListener('resize', this.resizeHandler);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
  height: max-content;
  background: #2c2c2e;
}
.top-panel {
  width: 100%;
  height: 50px;
  background: rgba(44, 44, 46, 1);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(0, 0, 0, 1);
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn {
  cursor: pointer;
  color: white;
  background: rgba(72, 72, 74, 1);
  border-radius: 4px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  line-height: 1;
  justify-content: center;
  border: 1px solid rgba(100, 100, 102, 1);
  &.active {
    background: #0884ff;
  }
}
.funcButton {
  width: 56px;
  height: 22px;
  font-size: 12px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  & + .funcButton {
    margin-left: 10px;
  }
  &.disabled {
    background-color: #716d6d;
    pointer-events: none;
  }
}
.scaleButton {
  background-color: #535353;
  padding: 0 10px;
  box-sizing: border-box;
  svg {
    display: block;
  }
  .scaleMinus {
    border-radius: 50%;
    font-size: 14px;
    margin-right: 5px;
    fill: #fff;
    box-shadow: #f1f1f1 0px 0px 4px;
    transition: box-shadow 0.1s;
    &:active {
      box-shadow: none;
    }
  }
  ::v-deep .scaleInput .el-input__inner {
    width: 30px;
    padding: 0;
    text-align: center;
    font-size: 12px;
  }
  .scalePlus {
    border-radius: 50%;
    font-size: 14px;
    margin-left: 5px;
    box-shadow: #f1f1f1 0px 0px 4px;
    transition: box-shadow 0.1s;
    &:active {
      box-shadow: none;
    }
  }
}
.input {
  margin: 0 24px;
}
.rotate {
  top: 100px;
  font-size: 20px;
  right: 30px;
  display: flex;
  z-index: 1;
  position: absolute;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.container-panel {
  width: 100%;
  height: max-content;
  display: flex;
  .left-panel {
    height: 100%;
    flex: 1;
    display: flex;
    .floors-wrapper {
      width: 140px;
      height: 100%;
      flex: 0 0 auto;
      background: rgba(44, 44, 46, 1);
      .floor {
        width: 90%;
        margin: 15px 5%;
        cursor: pointer;
        color: white;
        border-radius: 4px;
        background: #3b3b3c;
        padding: 10px;
        font-size: 14px;
        &.active {
          background: rgba(8, 132, 255, 1);
        }
      }
    }
    .container-wrapper {
      flex: 1;
      height: 100%;
      background: black;
      .btns {
        color: #fff;
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 12px;
        justify-content: space-between;
        padding: 0 10px;
        .left {
          display: flex;
          align-items: center;
          .btn {
            margin-right: 10px;
          }
        }
        .right {
          display: flex;
          align-items: center;
        }
      }
      .containers-box {
        width: 800px;
        height: 800px;
        position: relative;
      }
      .containers {
        z-index: 0;
        position: relative;
        width: 800px;
        height: 800px;
        display: block;
        .img {
          pointer-events: none;
          z-index: 1;
          position: absolute;
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .map {
          width: 100%;
          height: 100%;
          background: #ccc;
        }
        .container {
          display: block;
          float: left;
          position: relative;
          flex: 0 0 50%;
          height: 100%;
          background: white;
          .zoom-btn {
            position: absolute;
            right: 10px;
            top: 5px;
            cursor: pointer;
            z-index: 1000;
            width: 30px;
            height: 30px;
          }
          .c {
            position: relative;
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .form-panel {
    background: #2c2c2e;
    color: white;
    width: 260px;
    height: 100%;
    padding: 20px;
    .btn {
      font-size: 14px;
      margin-top: 20px;
    }
  }
  .jsonViewer {
    margin-top: 24px;
    background: #4a4a4a;
  }
}
</style>
